import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, PseudoInput, PseudoTextarea, PseudoSelect, Text } from './elements';

class Input extends Component {
  render() {
    const { ...props } = this.props;

    return (
      <Container
        paddingB={props.message}
        paddingT={props.label}
        marginT={props.marginT}
        marginB={props.marginB}
      >
        {props.label && <Text>{props.label}</Text>}

        {props.select && <PseudoSelect {...props}>{props.children}</PseudoSelect>}

        {props.s && (
          <PseudoTextarea {...props} rows="3">
            {props.children}
          </PseudoTextarea>
        )}

        {props.input && <PseudoInput {...props} />}

        {props.message && (
          <Text
            primary={props.primary}
            default={props.default}
            success={props.success}
            info={props.info}
            danger={props.danger}
          >
            {props.message}
          </Text>
        )}
        {props.errorMessage && (
          <Text
            danger
            marginT="5"
          >
            {props.errorMessage}
          </Text>
        )}
      </Container>
    );
  }
}

Input.propTypes = {
  type: PropTypes.string.isRequired,
};

export default Input;
